import React from 'react'
import withLayout from '../../../layout/withLayout'
import { lifecycle } from 'recompose'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import Input from '../../../form/component/Input'
import { formatDateTime } from '../../../../util/datetime'
import { Link } from 'react-router-dom'

export const CANCEL_CATEGORY = [
    {
        id: 'fake',
        value: 'fake',
    },
    {
        id: 'test',
        value: 'test',
    },
    {
        id: 'cancelledbyhq',
        value: 'Cancelled by HQ',
    },
    {
        id: 'rescheduledbyhq',
        value: 'Rescheduled by HQ',
    },
]


const Appointment = ({ appointment, salutationList, changeAppointment, setAppointmentCancelCategory }) => {
    if (!appointment) {
        return null
    }
    const aStore = appointment.store;

    const noop = () => {
    }

    return (
        <ContentBox title="Appointment">
            <Row>
                <Column size={6}>
                    <LabelInput label="Change Appointment Category">
                        <Select object={appointment}
                            name="cancelCategory"
                            readOnly={false}
                            addEmpty={true}
                            onChange={(name, value) => {
                                changeAppointment(name, value)
                                setAppointmentCancelCategory()
                            }}
                            valueList={CANCEL_CATEGORY}
                        />
                    </LabelInput>
                </Column>
            </Row>
            <Row top="M">
                <Column size={6}>
                    {appointment.externalChangeUrl && (
                        <a href={appointment.externalChangeUrl} className="btn btn-danger btn-sm" target="_blank" rel="noopener noreferrer">Change Appointment&#160;<i className="fa fa-external-link"/></a>)}
                </Column>
            </Row>

            <Row top="M">
                <Column size={4}>
                    <table className="info-table">
                        <tbody>
                            <tr>
                                <td>Customer</td>
                                <td><Link to={'/customer/edit/' + appointment.customerId}>{appointment.firstName + ' ' + appointment.lastName}</Link></td>
                            </tr>
                            {appointment.processInstanceId && (
                                <tr>
                                    <td>Process</td>
                                    <td><Link to={'/process/instance/view/' + appointment.processInstanceId}>Process</Link></td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </Column>
                <Column size={8}/>
            </Row>
            <Row top="M">
                <Column size={6}>
                    <LabelInput label="Salutation">
                        <Select object={appointment}
                            name="gender"
                            readOnly={true}
                            valueList={salutationList}
                        />
                    </LabelInput>
                </Column>
                <Column size={6}>


                </Column>
            </Row>
            <Row>
                <Column size={6}>
                    <LabelInput label="Firstname" groupAddOnIcon="fa fa-info">
                        <Input
                            object={appointment}
                            name="firstName"
                            onChange={noop}
                            readOnly={true}
                            onBlur={noop}/>
                    </LabelInput>
                </Column>
                <Column size={6}>
                    <LabelInput label="Lastname" groupAddOnIcon="fa fa-info">
                        <Input
                            object={appointment}
                            name="lastName"
                            onChange={noop}
                            readOnly={true}
                            onBlur={noop}/>
                    </LabelInput>
                </Column>
            </Row>
            <Row>
                <Column size={6}>
                    <LabelInput label="Email" groupAddOnIcon="fa fa-info">
                        <Input
                            object={appointment}
                            name="email"
                            onChange={noop}
                            readOnly={true}
                            onBlur={noop}/>
                    </LabelInput>
                </Column>
                <Column size={6}>
                    <LabelInput label="Phone" groupAddOnIcon="fa fa-info">
                        <Input
                            object={appointment}
                            name="phone"
                            onChange={noop}
                            readOnly={true}
                            onBlur={noop}/>
                    </LabelInput>
                </Column>
            </Row>
            <Row>
                <Column size={6}>
                    <LabelInput label="Start Time" groupAddOnIcon="fa fa-info">
                        <input className="form-control" readOnly={true} value={formatDateTime(appointment.startTime)}/>
                    </LabelInput>
                </Column>
                <Column size={6}>
                    <LabelInput label="End Time" groupAddOnIcon="fa fa-info">
                        <input className="form-control" readOnly={true} value={formatDateTime(appointment.endTime)}/>
                    </LabelInput>
                </Column>
            </Row>
            <Row>
                <Column size={6}>
                    {aStore &&
                    <LabelInput label="Store" groupAddOnIcon="fa fa-info">
                        <Input
                            object={aStore}
                            name="technicalName"
                            onChange={noop}
                            readOnly={true}
                            onBlur={noop}/>
                    </LabelInput>
                    }
                </Column>
                <Column size={6}>
                </Column>
                <Column size={6}>
                    <LabelInput label="Status" groupAddOnIcon="fa fa-info">
                        <Input
                            object={appointment}
                            name="status"
                            onChange={noop}
                            readOnly={true}
                            onBlur={noop}/>
                    </LabelInput>
                </Column>

            </Row>
        </ContentBox>
    )
}

export default lifecycle({
    componentDidMount () {
        this.props.findAppointment(this.props.appointmentId)
    },
})(withLayout(Appointment))



// WEBPACK FOOTER //
// ./src/modules/appointment/component/detail/AppointmentDetail.js